export default __webpack_public_path__ + "static/wso2-9af9566c289a7f12bc4754997a76be20.svg";